type AnimalLinkProps = {
  tagName: string;
  openInNewTab?: boolean;
  stopPropagation?: boolean;
};

export const AnimalLink = ({
  tagName,
  openInNewTab,
  stopPropagation,
}: AnimalLinkProps) => {
  const url = `/animal-management?search=${encodeURIComponent(tagName)}`;
  return (
    <a
      href={url}
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      {...(openInNewTab
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {})}
    >
      {tagName}
    </a>
  );
};
